import { useNavigate, useParams } from 'react-router-dom';

import config from '../../../../config/config';

import RegisterCompanyPage from '../company';
import RegisterPersonPage from '../person';

export default function TypeSelect() {
  const params = useParams();
  const navigate = useNavigate();
  const { USERS_TYPES } = config;

  if (!USERS_TYPES.includes(params.type || '')) {
    navigate('/');
  }

  return (
    <>
      {params.type !== 'company' ? <RegisterPersonPage /> : <RegisterCompanyPage />}
    </>
  );
}
